"use client"

import { QuestionResponse } from "@/services/practice"
import { toast } from "sonner"
import { Copy } from "lucide-react"

interface QuestionInfoBarProps {
    question: QuestionResponse;
    currentIndex: number;
    total: number;
}

export function QuestionInfoBar({ question, currentIndex, total }: QuestionInfoBarProps) {
    const copyQuestionId = () => {
        navigator.clipboard.writeText(question.questionId);
        toast.success("Question ID copied to clipboard");
    }

    return (
        <div className="hidden md:flex bg-[#935BE2] text-white px-6 py-2.5 items-center justify-center w-full overflow-hidden shadow-sm">
            <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-2 max-w-7xl mx-auto w-full">
                <div className="flex flex-col items-start">
                    <span className="opacity-70 text-sm font-bold uppercase tracking-widest mb-0.5">Question ID</span>
                    <button
                        onClick={copyQuestionId}
                        className="text-sm font-bold flex items-center gap-1.5 hover:bg-white/20 rounded px-1.5 -ml-1.5 py-0.5 transition-colors cursor-pointer group active:scale-95"
                        title="Click to copy Question ID"
                    >
                        <span className="truncate max-w-[180px]">#{question.questionId}</span>
                        <Copy className="h-3.5 w-3.5 opacity-50 group-hover:opacity-100 transition-opacity" />
                    </button>
                </div>
                <div className="hidden md:flex flex-col items-start">
                    <span className="opacity-70 text-sm font-bold uppercase tracking-widest mb-0.5">Domain</span>
                    <span className="text-sm font-semibold truncate max-w-[200px]">{question.domainName}</span>
                </div>
                <div className="hidden md:flex flex-col items-start">
                    <span className="opacity-70 text-sm font-bold uppercase tracking-widest mb-0.5">Skill</span>
                    <span className="text-sm font-semibold truncate max-w-[250px]">{question.skillName}</span>
                </div>
                <div className="hidden sm:flex flex-col items-start">
                    <span className="opacity-70 text-sm font-bold uppercase tracking-widest mb-0.5">Difficulty</span>
                    <span className="text-sm font-semibold">{question.difficulty || "Medium"}</span>
                </div>
                <div className="hidden lg:flex flex-col items-start">
                    <span className="opacity-70 text-sm font-bold uppercase tracking-widest mb-0.5">Score Band</span>
                    <span className="text-sm font-semibold">1</span>
                </div>
                {(question.reviewerName || question.reviewerId) && (
                    <div className="hidden xl:flex flex-col items-start">
                        <span className="opacity-70 text-sm font-bold uppercase tracking-widest mb-0.5">Reviewer</span>
                        <span className="text-sm font-semibold truncate max-w-[150px]">{question.reviewerName || `Assigned`}</span>
                    </div>
                )}
            </div>
        </div>
    )
}

